// extracted by mini-css-extract-plugin
export default {"PhoneButton_mobile":"phoneButton_PhoneButton_mobile__DsmQI","PhoneButton_desktop":"phoneButton_PhoneButton_desktop__Ez9EP"};